export default __webpack_public_path__ + "static/media/laptop.4cb190f2.svg";